const doc = [({"en":({"js":({"admin":({"tenant_domains":({"select":({"choose_tenant_domain":"Choose tenant domain"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;